import { Link } from "react-router-dom";
import { groups } from "../data";
import { insightArticles } from "../content";
import Seo from "../components/Seo";

const utility = [
  ["/", "Home"], ["/insights", "Insights"], ["/insights/articles", "Articles"], ["/insights/resources", "Resources"],
  ["/insights/events", "Events"], ["/about", "About"], ["/about/story", "Our Story"],
  ["/about/leadership", "Leadership"], ["/careers", "Careers"], ["/investors", "Investors"],
  ["/partnership", "Partnership"], ["/contact", "Contact"], ["/privacy-policy", "Privacy Policy"],
  ["/terms-of-use", "Terms of Use"], ["/cookie-policy", "Cookie Policy"], ["/sitemap", "Sitemap"],
];

export default function SitemapPage() {
  return (
    <section className="sitemap-page">
      <Seo title="Sitemap" description="Browse every public Medein website page." />
      <p className="section-label">Sitemap</p>
      <h1>Every public page.</h1>
      <div className="sitemap-grid">
        {Object.entries(groups).map(([key, group]) => (
          <section key={key}>
            <h2><Link to={`/${key}`}>{key.replace("-", " ")}</Link></h2>
            {group.items.map((item) => <Link key={`${key}-${item.slug}`} to={`/${key}/${item.slug}`}>{item.title}</Link>)}
          </section>
        ))}
        <section>
          <h2>Company & content</h2>
          {utility.map(([path, label]) => <Link key={path} to={path}>{label}</Link>)}
          {insightArticles.map((article) => <Link key={article.slug} to={`/insights/articles/${article.slug}`}>{article.title}</Link>)}
        </section>
      </div>
    </section>
  );
}
